import React, { useState } from 'react';
import styled from 'styled-components';
import {
  ListBoxItem,
  ListText,
  ListTitle,
  ListSubtitle,
  ListButton,
  BoxListWrap,
} from "../../../../assets/styles/BusinessAnalysisStyle";
import {
  Body1,
  Body3,
  Caption1,
} from "../../../../assets/styles/Typography";
import { Button } from "../../../../assets/styles/ButtonStyle";
import { CheckBoxButton } from '../../../../assets/styles/InputStyle';
import { palette } from '../../../../assets/styles/Palette';



const MoleculeSelectData = ({ title, subtitle, isSelected, onSelect, id, disabled, question, onAnswerChange }) => {
  const [showQuestions, setShowQuestions] = useState(false);

  const handleQuestionClick = () => {
    setShowQuestions(!showQuestions);
  };


  return (
    <ListBoxItem 
      selected={isSelected} 
      active={isSelected} 
      Small 
      style={{ 
        marginBottom: '0px',
        position: 'relative',
        padding: '16px'
      }}
      showQuestions={showQuestions}
    >
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        position: 'relative',
        width: '100%',
        minHeight: '48px'
      }}>
        <div style={{ 
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '24px',
          height: '100%'
        }}>
          <CheckBoxButton
            id={id}
            name={id}
            checked={isSelected}
            onChange={() => onSelect(id)}
            disabled={disabled}
            style={{ 
              cursor: 'pointer',
              margin: 0
            }}
          />
        </div>
        <ListText style={{ 
          flex: 1, 
          minWidth: 0, 
          paddingRight: question ? '120px' : '16px',
          display: 'flex',
          flexDirection: 'column',
          gap: '4px'
        }}>
         
          <ListSubtitle>
            <Body1 
              style={{ 
                fontSize: '14px',
                textAlign: 'left',
                wordBreak: 'break-word',
                whiteSpace: 'pre-wrap'
              }} 
              color="gray800"
            >
              {subtitle}
            </Body1>
          </ListSubtitle>
          <ListTitle style={{ marginBottom: '0' }}>
            <Caption1 
              style={{ 
                fontSize: '14px', 
                lineHeight: '1.3' 
              }} 
              color={isSelected ? "primary" : "gray500"}
            >
              {title}
            </Caption1>
          </ListTitle>
        </ListText>

          <ListButton style={{ 
            position: 'absolute',
            right: '16px',
            top: '50%',
            transform: 'translateY(-50%)',
            width: '86px'
          }}>
            <Button
              Medium
              {...(isSelected
                ? { PrimaryLightest: true, Fill: true }
                : { View: true })}
              onClick={() => onSelect(id)}
              style={{
                width: '100%'
              }}
            >
              {isSelected ? "선택됨" : "선택하기"}
            </Button>
          </ListButton>
   
      </div>

      
     
      
    </ListBoxItem>
  );
};

const BgBoxList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin-top: 4px;
`;

const BgBoxItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  padding: 12px 16px;
  border-radius: 8px;
  background: ${palette.chatGray};
`;

export default MoleculeSelectData;


const ImportanceContainer = styled.div`
   display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: 20px;
  width: 100%;
  box-sizing: border-box;
`;

const ImportanceDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #E0E4EB;
`;

const ImportanceButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  align-items: stretch;
  gap: 20px;
  width: 100%;
`;

const ImportanceButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
  background-color: ${props => props.isSelected ? '#226FFF' : '#F7F8FA'};
  border: 1px solid #E0E4EB;
  border-radius: 10px;
  height: 80px;
  flex: 1;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: ${props => props.isSelected ? '#226FFF' : '#EAECF0'};
  }
`;

const ImportanceButtonText = styled.span`
  font-family: 'Pretendard', 'Poppins';
  font-weight: 400;
  font-size: 16px;
  line-height: 1.55;
  letter-spacing: -0.03em;
  text-align: center;
  color: ${props => props.isSelected ? '#FFFFFF' : '#666666'};
  white-space: pre-line;
`;

const NPSContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: 20px;
  width: 100%;
  box-sizing: border-box;
`;

const NPSDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #E0E4EB;
`;

const NPSButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  align-items: stretch;
  gap: 16px;
  width: 100%;
`;

const NPSButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 12px;
  background-color: ${props => props.isSelected ? '#226FFF' : '#F7F8FA'};
  border: 1px solid #E0E4EB;
  border-radius: 10px;
  height: 64px;
  flex: 1;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: ${props => props.isSelected ? '#226FFF' : '#EAECF0'};
  }
`;

const NPSButtonText = styled.span`
  font-family: 'Pretendard', 'Poppins';
  font-weight: 400;
  font-size: 16px;
  line-height: 1.55;
  letter-spacing: -0.03em;
  text-align: center;
  color: ${props => props.isSelected ? '#FFFFFF' : '#666666'};
`;

const NPSLabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const NPSLabel = styled.span`
  font-family: 'Pretendard', 'Poppins';
  font-weight: 400;
  font-size: 16px;
  line-height: 1.55;
  letter-spacing: -0.03em;
  color: #666666;
`;